<template>
  <transition>
    <div class="member-tutorial">
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        @slide-change="slideChange"
      >
        <swiper-slide v-for="n in 6" :key="n">
          <div class="member-tutorial__content" :style="{'height': docHeight + 'px'}">
            <div class="member-tutorial__image"
              :style="{'background-image': 'url(/static/img/tutorial/tutorial' + n + '.png)'}"
            ></div>
          </div>
        </swiper-slide>
        <div v-show="!isLastSlide" class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <ArrowIcon
        v-show="!isLastSlide"
        class="swiper-button-prev"
        color="#fff"
        direction="left"
      />
      <ArrowIcon
        v-show="!isLastSlide"
        class="swiper-button-next"
        color="#fff"
        direction="right"
      />
      <div v-show="isLastSlide" class="member-tutorial__foot">
        <div class="member-tutorial__start" @click="onCloseClick">
          はじめる<ArrowIcon color="#fff" width="26" />
        </div>
      </div>
      <CloseIcon
        class="member-tutorial__close"
        color="#fff"
        @click.native="onCloseClick"
      />
    </div>
  </transition>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import CloseIcon from '@/utvStore/components/common/icon/CloseIcon'
import ArrowIcon from '@/utvStore/components/common/icon/ArrowIcon'

export default {
  name: "MemberTutorial",
  components: {
    swiper,
    swiperSlide,
    CloseIcon,
    ArrowIcon
  },
  data() {
    return {
      // スライドのオプション
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      // 最後のスライドなら true
      isLastSlide: false,
      // ドキュメントの高さ
      docHeight: ''
    }
  },
  computed: {
    // スライダー
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    onCloseClick(){
      this.$emit('tuto-close')
      // これをつけないと、閉じた時に初めのスライドに戻ってしまうので、苦肉の策
      this.swiper.removeAllSlides()
    },
    // スライドが変わる度に実行
    slideChange () {
      this.isLastSlide = this.swiper.isEnd ? true : false
    },
    // コンテンツの高さ設定
    handleResize () {
      // ブラウザのアドレスバーやナビゲーションバーの除いた高さを取得したいので
      this.docHeight = window.innerHeight
    }
  },
  mounted () {
    window.addEventListener('load', this.handleResize)
    window.addEventListener('resize', this.handleResize)
    // オーバースクロール対策
    document.documentElement.style.overflowY = 'hidden'
    document.documentElement.style.position = 'fixed'
    document.documentElement.style.width = '100%'
  },
  beforeDestroy: function () {
    window.removeEventListener('load', this.handleResize)
    window.removeEventListener('resize', this.handleResize)
    document.documentElement.style.overflowY = ''
    document.documentElement.style.position = ''
    document.documentElement.style.width = ''
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.member-tutorial {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: linear-gradient(150.65deg, rgba(255, 116, 151, 0.56) 18.23%, rgba(203, 139, 255, 0.56) 80.21%);
  z-index: 98000;
  &__content {
    box-sizing: border-box;
    padding: 40px 0 60px;
    height: 100vh;
    margin: 0 auto;
    max-width: 580px;
  }
  &__image {
    background: no-repeat 50% 50%/contain;
    height: 100%;
  }
  &__close {
    position: fixed;
    top: 19px;
    right: 18px;
    z-index: 98004;
  }
  &__foot {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 98003;
    background: linear-gradient(70.71deg, #FF7497 21.4%, #CB8BFF 76.64%);
    padding: 13.5px 0;
    height: 65px;
    text-align: center;
  }
  &__start {
    display: inline-block;
    margin: 0 0 0 6%;
    padding: 5px 10px;
    font-weight: bold;
    font-size: 18px;
    color: #FFFFFF;
    .arrow-icon {
      vertical-align: -6px;
    }
  }
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.6s ease-in;
}
.v-enter, .v-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
.member-tutorial {
  .swiper-container {
    height: 100vh;
  }
  .swiper-slide {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .swiper-pagination {
    position: fixed;
    bottom: 0;
    z-index: 98001;
    background: linear-gradient(70.71deg, #FF7497 21.4%, #CB8BFF 76.64%);
    padding: 21.5px 0;
    height: 65px;
  }
  .swiper-pagination-bullet {
    opacity: 0.14;
  }
  .swiper-pagination-bullet-active {
    background: #fff;
    opacity: 1;
  }
  .swiper-button-prev,
  .swiper-button-next {
    background: none;
    width: 30px;
    height: 30px;
    position: fixed;
    bottom: 17px;
    top: unset;
    margin: 0;
    z-index: 98002;
  }
  .swiper-button-prev { left: 15px;}
  .swiper-button-next { right: 15px;}
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/MemberTutorial.vue